import * as Yup from "yup";
export const formikLogin = {
    initialValues: {
        email: "",
        password: "",
        showPassword : true
    },
    validationSchema: Yup.object({
        email: Yup.string().email().required("Required Field"),
        password: Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at-least 8 characters, one uppercase, one lowercase, one number and one special character."
        ).required("Required Field")
    })
};

export const formikSignUp = {
  initialValues: {
    username: "",
    email: "",
    password: ""
  },
  validationSchema: {
    username: Yup.string().required("Required").max(50),
    password: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        "Password must contain at-least 8 characters, one uppercase, one lowercase, one number and one special character."
      )
      .required("Required"),
    email: Yup.string().email().required("Required")
  }
};

export const formikForgotPass = {
  initialValues: {
      email: ""
  },
  validationSchema: Yup.object({
      email: Yup.string().email().required("Required Field")
  })
};

export const formikResetPassword = {
  initialValues: {
      newPassword: "",
      otp : "",
      email : "",
      showPassword : true,
      showCPassword : true
  }
};
